import { HeroSection } from '../components/home/HeroSection';
import { StatsBar } from '../components/home/StatsBar';
import { WebsitePromo } from '../components/home/WebsitePromo';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { ServicesPreview } from '../components/home/ServicesPreview';
import { Testimonials } from '../components/home/Testimonials';
import { PricingTeaser } from '../components/home/PricingTeaser';
import { CtaSection } from '../components/home/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <HeroSection />
      <StatsBar />
      <WebsitePromo />
      <WhyChooseUs />
      <ServicesPreview />
      <Testimonials />
      <PricingTeaser />
      <CtaSection />
    </div>
  );
}
